module.exports = __webpack_public_path__ + "img/prod_item_def.c13ae5db.png";